import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import AsyncSelect from "components/InputsField/formikInputs/AsyncSelect";
import FormikCheckboxField from "components/InputsField/formikInputs/FormikCheckboxField";
import { percentsInput } from "components/InputsField/inputFormats";
import Title from "components/common/Layout/Title";
import FormRow from "components/common/Layout/FormRow";
import InputNote from "components/InputsField/InputNote";

import styles from "./styles.module.scss";
import { UTILS } from "endpointsConst";
export default function Payment() {
    const { t } = useTranslation();
    const lang = useSelector((state) => state.settings.lang);

    const getPaymentTranslate = (str) => t("transportFields.payment_section." + str);

    return (
        <>
            <Title withMargin>{getPaymentTranslate("heading")}</Title>
            <FormRow>
                <FormRow withSpace>
                    <AsyncSelect
                        url={`${UTILS}/paymentRateTypes/?lang=${lang}`}
                        label={getPaymentTranslate("type_payment")}
                        name="payment_rate_type_id"
                        isClearable={true}
                        className={styles["payment__type"]}
                    />
                    <FormikTextField
                        label={getPaymentTranslate("prepayment")}
                        name="prepayment"
                        placeholder="0"
                        postfix="%"
                        format={percentsInput}
                    />
                </FormRow>
                <FormRow>
                    <div className={styles.checkbox}>
                        <FormikCheckboxField
                            name="upload"
                            id="upload"
                            label={getPaymentTranslate("unloading_box")}
                        />
                    </div>
                </FormRow>
            </FormRow>
            <FormRow withMargin>
                <div>
                    <FormikCheckboxField
                        name="direct_contract"
                        id="direct_contract"
                        label={getPaymentTranslate("contract_box")}
                    />
                    <div className={styles.wrapperNote}>
                        <InputNote note={getPaymentTranslate("contract_note_customer")} />
                    </div>
                </div>
            </FormRow>
        </>
    );
}
